module.exports = __webpack_public_path__ + "/login_ui/img/zw-bf3ca7ab2864d3e06d7f2e5b6cfc6048.svg";